import MTextWithHint from './MTextWithHint.vue';

export { MTextWithHint };
export default MTextWithHint;
